<template>
    <div class="box">
        <div class="login-container" :class="{ 'vertical-layout': isLayoutVertical }">
            <div class="login-left">
                <div class="text-box">
                    <h1 v-if="!isLayoutVertical">鑫易付</h1>
                    <h1 v-else>鑫易付商户系统</h1>
                    <div v-if="!isLayoutVertical" style="font-size: 14px;">
                        <p>欢迎使用鑫易付商户系统</p>
                        <p>
                            <el-icon color="#67C23A">
                                <SuccessFilled />
                            </el-icon>&nbsp;支付
                        </p>
                        <p>
                            <el-icon color="#67C23A">
                                <SuccessFilled />
                            </el-icon>&nbsp;渠道
                        </p>
                        <p>
                            <el-icon color="#67C23A">
                                <SuccessFilled />
                            </el-icon>&nbsp;营销
                        </p>
                    </div>
                </div>
                <div v-if="!isLayoutVertical" style="position: absolute; bottom:-50px; color: #fff; font-size: 14px;">©
                    {{
                        copyrightYear }} All
                    Rights
                    Reserved. 鑫易付</div>
                <div v-else style="position: absolute; bottom:-180px; color: #fff; font-size: 14px;">© {{ copyrightYear
                    }}
                    All
                    Rights
                    Reserved. 鑫易付</div>
            </div>

            <div class="login-right">
                <div v-if="!isLayoutVertical" style="padding-left: 53px; padding-top: 10px;color:#fff;">
                    <h3>登录:</h3>
                    <p>鑫易付商户系统</p>
                </div>

                <div class="login-box">
                    <el-form ref="loginForms" :model="loginForm" :rules="loginRules" hide-required-asterisk>
                        <!-- 新增：用户类型选择 -->
                        <el-form-item prop="userType">
                            <el-select v-model="loginForm.type" placeholder="请选择用户类型" size="large" style="width: 100%">
                                <el-option label="商户" value="1" />
                                <el-option label="门店" value="2" />
                            </el-select>
                        </el-form-item>

                        <el-form-item prop="no">
                            <el-input type="text" v-model="loginForm.no" size="large" placeholder="请输入商户号" clearable />
                        </el-form-item>

                        <el-form-item prop="password">
                            <el-input type="password" v-model="loginForm.password" size="large" placeholder="请输入密码"
                                clearable show-password />
                        </el-form-item>
                        <!-- <el-form-item prop="no">
                            <el-select v-model="loginForm.no" placeholder="请选择商户" style="width: 100%;" size="large" clearable>
                                <el-option v-for="(item, index) in option" :key="index" :label="item.merchant_alias"
                                    :value="item.no" />
                            </el-select>
                        </el-form-item> -->
                        <el-form-item prop="verifyCode">
                            <el-input v-if="!isLayoutVertical" v-model="loginForm.verifyCode" placeholder="请输入验证码"
                                clearable size="large" style="width: 200px;" />
                            <el-input v-else v-model="loginForm.verifyCode" placeholder="验证码" clearable size="large"
                                style="width: 95px;" />
                            <SIdentify :contentWidth="100" :contentHeight="40"
                                style="line-height: 10px; margin-left: 10px;" :identifyCode="identifyCode"
                                @click="refreshCode"></SIdentify>
                        </el-form-item>

                        <el-button type="primary" @click="login" size="large" style="font-size: 16px;width: 100px;"
                            :loading="loginForm.loading">登录</el-button>
                    </el-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, getCurrentInstance } from 'vue';
import { useRouter } from 'vue-router'
import { SuccessFilled } from '@element-plus/icons-vue'
import SIdentify from '@/components/CustomSidentify/Sidentify'
import { ElMessage } from 'element-plus'
const { proxy } = getCurrentInstance()
const router = useRouter()
const copyrightYear = new Date().getFullYear()
const loginForms = ref()
const loginForm = ref({
    username: '',
    password: '',
    verifyCode: '',
    no: '',
    type: '1',
    loading: false, // 添加loading属性
});
// const option = ref([])
const loginRules = ref({
    no: [{ required: true, message: '请输入商户号', trigger: 'blur' }],
    password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
    verifyCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
    // no: [{ required: true, message: "请选择商户", trigger: "blur" }],
})

let identifyCode = ref('') //图形验证码
let identifyCodes = ref('1234567890abcdefghijklmnobqrstuvwxyz') //验证码出现的数字和字母

// 生成随机数
const randomNum = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1) + min)
}
// 随机生成验证码字符串
const makeCode = (o, l) => {
    identifyCode.value = ''
    for (let i = 0; i < l; i++) {
        const randomIndex = randomNum(0, o.length - 1)
        identifyCode.value += o[randomIndex]
    }
}

// 更新验证码
const refreshCode = () => {
    identifyCode.value = ''
    makeCode(identifyCodes.value, 4)
}

const isLayoutVertical = ref(false);

const handleResize = () => {
    isLayoutVertical.value = window.innerWidth < 800;
};

// const queryMerchantsNO = (phone) => {
//     if (!(/^1[3456789]\d{9}$/.test(phone))) {
//         ElMessage({ message: `请输入正确的手机号`, type: 'warning', })
//         return false;
//     } else {
//         proxy.$api.queryno({ phone: phone }).then(res => {
//             if (res.status == 200 && res.success) {
//                 option.value = res.data
//             } else {
//                 ElMessage({ message: `${res.error.message}`, type: 'warning', })
//             }
//         })
//     }
// };



const login = () => {
    loginForms.value.validate((valid) => {
        loginForm.value.loading = true;
        if (valid && loginForm.value.verifyCode.toLowerCase() === identifyCode.value.toLowerCase()) {
            // 表单校验通过且验证码正确，执行登录逻辑
            proxy.$api.login({ no: loginForm.value.no, password: loginForm.value.password, type: loginForm.value.type }).then(res => {
                if (res.status == 200 && res.success) {
                    const token = {
                        access_token: res.data.access_token,
                        expires_in: res.data.expires_in,
                        token_type: res.data.token_type,
                        begin_time: new Date().getTime()
                    }
                    sessionStorage.setItem('token', JSON.stringify(token))
                    sessionStorage.setItem('merchant_user', JSON.stringify(res.data.user))
                    router.push({ path: '/dashboard' })
                } else {
                    ElMessage({ message: `${res.error.message}`, type: 'warning' })
                }
            }).catch(error => {
                ElMessage({ message: '登录失败', type: 'error' })
                console.log(error);
            }).finally(() => {
                loginForm.value.loading = false;
            });
        } else {
            // 表单校验不通过或验证码不正确，提示错误信息
            ElMessage({ message: '未完成填写或验证码错误', type: 'error' })
            loginForm.value.loading = false
            refreshCode()
        }
    });
};



onMounted(() => {
    window.addEventListener('resize', handleResize);
    handleResize();
    identifyCode.value = ''
    makeCode(identifyCodes.value, 4)
});

onBeforeUnmount(() => {
    window.removeEventListener('resize', handleResize);
});
</script>

<style lang="less" scoped>
.box {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url('../../assets/login-background.jpg');
    background-size: cover;
    background-position: center;
    display: flex;
    justify-content: center;

    .login-container {
        margin-top: 10%;
        display: flex;
        width: 800px;
        height: 400px;
        padding-bottom: 20px;
        border-bottom: 1px solid #fff;

        &.vertical-layout {
            flex-direction: column;
            border-bottom: none;

            .login-left {
                order: 1;
                align-items: center;
                margin-bottom: -200px;
            }

            .login-right {
                order: 2;
                margin-top: 5%;
                padding-top: 5%;
                margin-left: 20%;
                margin-right: 20%;

                .login-box {
                    padding-left: 10px;
                    padding-right: 10px;
                    padding-bottom: 10px;
                }
            }
        }

        .login-left {
            position: relative;
            display: flex;
            flex: 1.2;
            flex-direction: column;
            height: 100%;

            .text-box {
                color: #fff;
            }
        }

        .login-right {
            display: flex;
            flex: 1.3;
            flex-direction: column;
            background-color: rgba(255, 255, 255, 0.3);
            border-radius: 5px;
            height: 100%;

            .login-box {
                padding-left: 20px;
                padding-right: 20px;
                text-align: center;
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }
    }
}
</style>